import React from "react";

import svgs from "./svgs";

type Props = {
  id?: string;
  name: string;
  size?: string;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
};

const SVG = ({ id, name, size, className, onClick, tabIndex }: Props) => {
  const svgName = `SVG_${name}`;
  const SVGComponent: React.FC<React.SVGAttributes<SVGElement>> = svgs[svgName as keyof typeof svgs];

  return (
    <SVGComponent
      id={id}
      style={{ width: size || "100%" }}
      className={className}
      onClick={onClick}
      tabIndex={tabIndex}
    />
  );
};

export default SVG;
